import * as React from "react";
import {cx} from "emotion";

import "./search-form.scss";

import {bindInput}       from "@Common/react/bind-input";
import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Form2}           from "@Common/react/cs-form-2/form2";
import {required}        from "@Common/react/cs-form-2/validators/required";
import {UseState}        from "@Common/react/use-state";
import {setNestedValue}  from "@Common/utils/arr-path";
import {chain}           from "@Common/utils/fs";
import {oKeyMapToArr,
        omit}            from "@Common/utils/objects";

import {isDevQuan}        from "../../../../../../../debug/is-dev-quan";
import {InformationBadge} from "../../../../../../common/design2/information-badge/information-badge";
import {Select}           from "../../../../../../common/design2/select/select";

import {SearchError} from "./search-error/search-error";

export const SearchForm = ({onAdd, isExisted, entityId}) => cs(
    consumeContext("apis"),
    ["searchError", (_, next) => UseState({
        next,
    })],
    ["searching", (_, next) => UseState({next})],
    ["data", (_, next) => UseState({
        initValue: {
            MFI: "1",
            ...isDevQuan() && {
                address: "1342 N CHURCH CT",
                "zip":"45305",
            },
        },
        next,
    })],
    ["search", ({apis, searchError, searching}, next) => next(async (form) => {
        if (isExisted(form)) {
            searchError.onChange({
                type: "existed",
                address: form.address,
            });
            return;
        }

        searching.onChange(true);

        try {
            searchError.onChange(null);

            const result = chain(
                await apis.next.mailing.searchStreet(form, entityId),
                (_) => Object["values"](_)[0],
            );
            if (result.result === "success") {
                const {addresses, ...street} = omit(result, ["result"]);

                if (isExisted(street)) {
                    // console.log(2, street)
                    searchError.onChange({
                        type: "existed",
                        address: street.address,
                    });
                    return;
                }

                onAdd({addresses, street});
            } else if (result.result === "alternateStreet" || result === "" || result.result === "failure") {
                searchError.onChange({
                    type: "notFound",
                    address: form.address,
                    zip: form.zip,
                    streets: result.alternateStreets,
                });
            } else if (result.result === "MultipleStreets") {
                searchError.onChange({
                    type: "multipleFound",
                    address: form.address,
                    zip: form.zip,
                    streets: oKeyMapToArr(result.streets),
                });
            } else {
                alert("Unknown error");
                // searchError.onChange({type: "unknown"});
            }
        } finally {
            searching.onChange(false);
        }
    })],
    ["form", ({search, data}, next) => Form2({
        data,
        fields: {
            "address" : [required],
            "zip"     : [required],
            "MFI"     : [required],
        },
        onSubmit: () => search(data.value),
        next,
    })],
    ({form, searchError, search, data, searching}) => (
        <div className="search-form search-form-7g3">
            <div className="form">

                <div className="form-group address">
                    <div className="control-label" xd-qa-type="label" xd-qa-name="Build Street List Street Name">
                        Street Name
                    </div>

                    {cs(
                        ["focus", (_, next) => UseState({next})],
                        ({focus}) => {
                            const field = form.field(["address"]);
                            return (
                                <div {...{
                                    className: cx("input", {
                                        focus: focus.value,
                                        hasError: field.error,
                                    }),
                                }}>
                                    <input {...{
                                        placeholder: "N Main St",
                                        onFocus: () => focus.onChange(true),
                                        onBlur: () => focus.onChange(false),
                                        maxLength: 50,
                                        ...chain(
                                            bindInput(field.state),
                                            (bind) => ({
                                                ...bind,
                                                onChange: (e) => {
                                                    bind.onChange(e);
                                                    if (searchError.value) {
                                                        searchError.onChange(null);
                                                    }
                                                },
                                            })
                                        ),
                                        "xd-qa-type": "text_field",
                                        "xd-qa-name": "Build Street List Street Name",
                                    }}/>

                                    {InformationBadge({
                                        getTooltip: () => (
                                            <ul className="message-5ww">
                                                <li>Include the street name you wish to target. Do not specify house or unit numbers.</li>
                                                <li>Omit periods following abbreviations.</li>
                                                <li>Abbreviate the cardinal direction in a street name (i.e. S for South. NW for Northwest)</li>
                                            </ul>
                                        ),
                                        xdQaName: "Build Street List Street Name"
                                    })}
                                </div>
                            );
                        }
                    )}
                </div>
                <div className="form-group zip">
                    <div className="control-label" xd-qa-type="label" xd-qa-name="Build Street List Zip Code">
                        Zip Code
                    </div>

                    {(() => {

                        const field = form.field(["zip"]);
                        return (
                            <input {...{
                                placeholder: "90210",
                                className: cx({hasError: field.error}),
                                maxLength: 10,
                                ...bindInput(field.state),
                                "xd-qa-type": "text_field",
                                "xd-qa-name": "Build Street List Zip Code",
                            }}/>
                        );
                    })()}
                </div>
                <div className="form-group address-type">
                    <div className="control-label" xd-qa-type="label" xd-qa-name="Build Street List Address Type">
                        Address Type
                    </div>

                    {(() => {
                        const field = form.field(["MFI"]);
                        return (
                            Select({
                                forcedExpandLeft: true,
                                list: [
                                    {
                                        label: "Single and Multi-Family",
                                        value: "1",
                                    },
                                    {
                                        label: "Single Family Only",
                                        value: "2",
                                    },
                                    {
                                        label: "Multi-Family Only",
                                        value: "3",
                                    },
                                ],
                                itemToLabel: (e) => e?.label,
                                onChange: (e) => field.state.onChange(e.value),
                                isSelected: (e) => field.state.value == e.value,
                                xdQaName: "Build Street List Address Type"
                            })
                        );
                    })()}
                </div>

                <div className="action">
                    <button {...{
                        className: cx({disabled: !form.valid}),
                        disabled: searching.value,
                        onClick: form.submit,
                        "xd-qa-type": "button",
                        "xd-qa-name": "Build Street List Add Street",
                    }}>
                        Add Street
                    </button>
                </div>
            </div>

            {searchError.value && (
                SearchError({
                    error: searchError.value,
                    onChangeStreet: (street) => {
                        searchError.onChange(null);
                        const newForm = setNestedValue(data.value, ["address"], street);
                        data.onChange(newForm);
                        search(newForm);
                    },
                })
            )}
        </div>
    )
);